var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('employment-doc-body', _vm._b({
    attrs: {
      "withoutReset": ""
    },
    model: {
      value: _vm.form.fields,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fields", $$v);
      },
      expression: "form.fields"
    }
  }, 'employment-doc-body', {
    mode: _vm.mode,
    pages: _vm.pages
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }